import {Column, Entity, ManyToMany, PrimaryColumn} from "typeorm"
import { Client } from "./Client"
import { User } from "./User"

@Entity()
export class PvpcMap {

	@PrimaryColumn({unique: true})
	name!: string

	@Column()
	id!: string

	@Column()
	accountId!: string

	@ManyToMany(() => Client, (client) => client.pvpcs)
  clients!: Client[]

}